import $ from 'jquery';
import Hammer from 'hammerjs';

const ClassName = {
  ACTIVE: 'toggle__switch--on',
  VISIBLE: 'toggle__target--visible',
};

class Tabs {
  constructor(element) {
    this.$container = $(element);
    this.sectionId = this.$container.attr('id');

    if (!this.sectionId) return;

    // Only find nav items and panels within this tab group
    this.$navItems = this.$container.find(`[data-toggle-switch^="${this.sectionId}"]`);
    this.$panels = this.$container.find(`[data-toggle-target^="${this.sectionId}"]`);

    this._setListeners();
    this._setupSwipe();
  }

  _setListeners() {
    this.$navItems.on('click', event => {
      event.preventDefault();
      const $target = $(event.currentTarget);
      const targetId = $target.data('toggle-switch');

      if (targetId.startsWith(this.sectionId)) {
        this._activateTab($target, targetId);
      }
    });
  }

  _setupSwipe() {
    const panelContainer = this.$container.find('.tabs__content')[0];
    if (!panelContainer) return;

    const hammer = new Hammer(panelContainer);
    hammer.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });

    hammer.on('swipeleft', () => this._goToNextTab());
    hammer.on('swiperight', () => this._goToPreviousTab());
  }

  _goToNextTab() {
    const $current = this.$navItems.filter(`.${ClassName.ACTIVE}`);
    const currentIndex = this.$navItems.index($current);
    const $next = this.$navItems.eq(currentIndex + 1);
    if ($next.length) {
      this._activateTab($next, $next.data('toggle-switch'));
    }
  }

  _goToPreviousTab() {
    const $current = this.$navItems.filter(`.${ClassName.ACTIVE}`);
    const currentIndex = this.$navItems.index($current);
    const $prev = this.$navItems.eq(currentIndex - 1);
    if ($prev.length) {
      this._activateTab($prev, $prev.data('toggle-switch'));
    }
  }

  _activateTab($navItem, targetId) {
    if (!targetId.startsWith(this.sectionId)) return;
    this.$container.find(`[data-toggle-switch^="${this.sectionId}"]`).removeClass(ClassName.ACTIVE);

    $navItem.addClass(ClassName.ACTIVE);

    this.$container.find(`[data-toggle-target^="${this.sectionId}"]`).removeClass(ClassName.VISIBLE);
    this.$container.find(`[data-toggle-target="${targetId}"]`).addClass(ClassName.VISIBLE);
  }
}

const tabs = selector => {
  $(selector || '[data-toggle-group="tab-section"]').each((index, element) => {
    new Tabs(element);
  });
};

export default tabs;
